import React, { useEffect, useState } from "react";
import {
  AnswerDto,
  QuestionDto,
  IsolatedInputDetails,
  AnswerUserReferenceDto,
} from "../../../../data/DailyOperational";
import { OptionDto } from "../../../../data/Option";
import { UserDto } from "../../../../data/User";
import { UserService } from "../../../../services/UserService";
import { IsolatedInput } from "../../CustomInput/IsolatedInput";

interface IIsolatedInputListProps {
  defaultItemsCount: number;
  preventExpanding?: boolean;
  answerDto?: AnswerDto[];
  userDto?: UserDto[];
  optionsDto?: OptionDto[];
  userSelected?: UserDto;
  usersSelected?: UserDto[];
  question?: QuestionDto;
  setData?: (value: QuestionDto | undefined) => void;
  date: Date;
  left: boolean;
  separateNumber: number;
}

interface IIsolatedInputListState {
  items: IsolatedInputDetails[];
}

function GenericIsolatedInputListCallList(props: IIsolatedInputListProps) {
  const [state, setState] = useState<Partial<IIsolatedInputListState>>({
    items: new Array<IsolatedInputDetails>(),
  });

  const getUserId = async (
    user: AnswerUserReferenceDto | undefined
  ): Promise<UserDto> => {
    return await UserService.getUser(user?.userId ?? 0);
  };

  const initialize = async () => {
    // setState({ userSelected: null })
    for (let i = 0; i < props.defaultItemsCount; i++) {
      const item: IsolatedInputDetails = {
        isFirst: i === 0,
        isLast: i === props.defaultItemsCount - 1,
      };
      setState((prevState) => ({
        ...prevState,
        items: [...(prevState.items || []), item],
      }));
    }
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSectionInputChanged = (isLast: boolean): void => {
    if (props.preventExpanding) return;
    if (!isLast) return;

    const items = state.items || [];
    items[items.length - 1].isLast = false;
    items.push({ isFirst: false, isLast: true });

    setState((prevState) => {
      return {
        ...prevState,
        items: items,
      };
    });
  };

  const setData = (question: QuestionDto | undefined) => {
    if (props.setData) {
      props.setData(question);
    }
  };

  return (
    <>
      {state.items?.map((item, index) => {
        return (
          <IsolatedInput
            key={index}
            userDto={props.userDto}
            optionsDto={props.optionsDto}
            isFirst={item.isFirst}
            isLast={item.isLast}
            question={props.question}
            answerDto={props.question?.answers?.find(
              (x) => x.order === props.separateNumber * (index + 1)
            )}
            onChange={handleSectionInputChanged}
            setData={setData}
            order={props.separateNumber * (index + 1)}
            date={props.date}
          />
        );
      })}
    </>
  );
}

export default GenericIsolatedInputListCallList;
